import React from 'react'
import { Link, navigate } from 'gatsby'
import Img from 'gatsby-image'
import mousetrap from 'mousetrap'
import Swipeable from './swipeable'

const socialLinks = []
const addSocial = (key, url) => {
  socialLinks.push({
    key,
    url,
    icon: require(`../images/social/iconmonstr-${key}-4.svg`),
  })
}
addSocial('twitter', 'https://twitter.com/')
addSocial('linkedin', 'https://linkedin.com/in/')
addSocial('youtube', 'https://www.youtube.com/channel/')
addSocial('medium', 'https://medium.com/@')
addSocial('reddit', 'https://reddit.com/u/')
addSocial('blog', '')

const PersonSocialLinks = ({ person }) => {
  const links = []

  socialLinks.forEach(({ key, url, icon }) => {
    if (person[key]) {
      links.push([key, icon, url + person[key]])
    }
  })

  return (
    <div className="social-links">
      {links.map(([key, icon, url]) => (
        <a href={url} key={key} target="_blank" rel="noreferrer">
          <img src={icon} title={key} alt={key} />
        </a>
      ))}
    </div>
  )
}

class PersonModal extends React.Component {
  componentDidMount() {
    mousetrap.bind('left', this.prev)
    mousetrap.bind('right', this.next)
  }

  componentWillUnmount() {
    mousetrap.unbind('left')
    mousetrap.unbind('right')
  }

  next = (e) => {
    if (e && e.event) {
      e.event.stopPropagation()
    } else if (e) {
      e.stopPropagation()
    }
    if (this.props.next) {
      navigate(`/who/${this.props.next}`)
    }
  }
  prev = (e) => {
    if (e && e.event) {
      e.event.stopPropagation()
    } else if (e) {
      e.stopPropagation()
    }
    if (this.props.prev) {
      navigate(`/who/${this.props.prev}`)
    }
  }

  render() {
    const { person, prev, next } = this.props

    if (!person) {
      return <div className="person-modal" />
    }

    const { first, last, title, bio, photocredit, portrait } = person

    return (
      <Swipeable
        className="person-modal"
        onSwipedLeft={this.next}
        onSwipedRight={this.prev}
      >
        <div className="back-bar">
          <Link to="/who/">
            <span className="arrow arrow-left" />
            <span className="close-text">Close</span>
          </Link>
        </div>
        <div className="person-detail">
          <div className="img-area">
            <Img
              fluid={portrait?.childImageSharp?.fluid}
              alt={first} key={first}
              style={{ position: 'initial' }}
            />
            <h2>
              {first} {last}
            </h2>
            {photocredit && <div className="credit">Photo: {photocredit}</div>}
          </div>
          <div className="bio-area">
            <h3>{title}</h3>
            <p>{bio}</p>
            <PersonSocialLinks person={person} />
            <div className="prev-next-links">
              {prev && <Link to={`/who/${prev}/`}>Prev</Link>}
              {!prev && <span>Prev</span>}
              {next && <Link to={`/who/${next}/`}>Next</Link>}
              {!next && <span>Next</span>}
            </div>
          </div>
        </div>
      </Swipeable>
    )
  }
}

export default PersonModal
